import '../styles.scss';
import React, { useEffect } from 'react';
import DateUtils from '../../../services/DateUtils';
import SessionList from '../components/SessionList';

export const RsvpLiteSessionsPage = ({account, sessions}) => {

    useEffect(() => {
        // Set account timeFormat
        DateUtils.setTimeFormatFromAccount(account.time_format);
        // Set locale for date formating
        DateUtils.setLocale();
    }, []);

    const bookedSessions    = sessions.filter(session => session.attendance);
    const availableSessions = sessions.filter(session => !session.attendance);

    return (
        <div className="rsvp-lite-container">
            {bookedSessions.length ? (
                <>
                    <h1 className="rsvp-lite-sessions-list-title">Booked Sessions</h1>
                    <SessionList sessions={bookedSessions} />
                </>
            ) : null}
            <h1 className="rsvp-lite-sessions-list-title">Available Sessions</h1>
            <SessionList sessions={availableSessions} />
        </div>
    );
}

export default RsvpLiteSessionsPage;
